import "styles/components/_button-group.scss";
import {ButtonGroup as CoreButtonGroup} from "@mantine/core";
import useBEM from "hooks/useBEM";

export default function ButtonGroup({className = '', ...props}) {
  const classes = useBEM('button-group');
  return <CoreButtonGroup className={classes({}, [className])} {...props}/>
}
